module.exports = __webpack_public_path__ + "static/media/izjava_o_pristupacnosti.93671e84.pdf";